import { RootState } from 'core/redux/types';
import { TelehealthBookingStep } from './types';

export function isTelehealthBookingOpen(state: RootState): boolean {
    return state.telehealthBooking.open;
}

export function getStep(state: RootState): TelehealthBookingStep {
    return state.telehealthBooking.step;
}

export function getError(state: RootState): string | null {
    return state.telehealthBooking.error;
}
